// Patch tagify component to work with dmxAppConnect

function ensureTagifyThemeStyles() {
  if (document.getElementById('dmx-tagify-theme-styles')) {
    return;
  }

  const style = document.createElement('style');
  style.id = 'dmx-tagify-theme-styles';
  style.textContent = `
    [data-bs-theme="dark"] .tagify {
      --tags-disabled-bg: rgba(255, 255, 255, 0.06);
      --tags-border-color: var(--bs-border-color, #495057);
      --tags-hover-border-color: var(--bs-secondary-color, #adb5bd);
      --tags-focus-border-color: var(--bs-primary, #6ea8fe);
      --tag-bg: color-mix(in srgb, var(--bs-tertiary-bg, #2b3035) 88%, var(--bs-body-color, #dee2e6) 12%);
      --tag-hover: color-mix(in srgb, var(--bs-secondary-bg, #343a40) 82%, var(--bs-primary, #6ea8fe) 18%);
      --tag-text-color: var(--bs-body-color, #dee2e6);
      --tag-text-color--edit: var(--bs-body-color, #dee2e6);
      --tag-remove-bg: rgba(220, 53, 69, 0.2);
      --tag-remove-btn-color: color-mix(in srgb, var(--bs-danger, #dc3545) 70%, #ffffff 30%);
      --tag-remove-btn-bg: rgba(255, 255, 255, 0.08);
      --tag-remove-btn-bg--hover: rgba(220, 53, 69, 0.24);
      --tag-invalid-color: color-mix(in srgb, var(--bs-danger, #dc3545) 75%, #ffffff 25%);
      --tag-invalid-bg: rgba(220, 53, 69, 0.2);
      --item-text-color: var(--bs-body-color, #dee2e6);
      --item-sec-color: var(--bs-secondary-color, #adb5bd);
      --item-count-color: var(--bs-secondary-color, #adb5bd);
      --input-color: var(--bs-body-color, #dee2e6);
      --placeholder-color: color-mix(in srgb, var(--bs-body-color, #dee2e6) 52%, transparent);
      --placeholder-color-focus: color-mix(in srgb, var(--bs-body-color, #dee2e6) 68%, transparent);
      background-color: var(--bs-body-bg, #212529);
      color: var(--bs-body-color, #dee2e6);
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
    }

    [data-bs-theme="dark"] .tagify:hover {
      background-color: color-mix(in srgb, var(--bs-body-bg, #212529) 90%, white 10%);
    }

    [data-bs-theme="dark"] .tagify[readonly],
    [data-bs-theme="dark"] .tagify[disabled] {
      background-color: var(--bs-tertiary-bg, #2b3035);
    }

    [data-bs-theme="dark"] .tagify__input::before {
      color: var(--placeholder-color);
    }

    [data-bs-theme="dark"] .tagify__dropdown,
    [data-bs-theme="dark"] .tagify__dropdown__wrapper {
      background: var(--bs-body-bg, #212529);
      border-color: var(--bs-border-color, #495057);
      color: var(--bs-body-color, #dee2e6);
      box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.35);
    }

    [data-bs-theme="dark"] .tagify__dropdown__item {
      color: var(--item-text-color);
    }

    [data-bs-theme="dark"] .tagify__dropdown__item:hover,
    [data-bs-theme="dark"] .tagify__dropdown__item--active,
    [data-bs-theme="dark"] .tagify__dropdown__item--selected {
      background: color-mix(in srgb, var(--bs-primary, #6ea8fe) 22%, var(--bs-body-bg, #212529) 78%);
      color: var(--bs-emphasis-color, #fff);
    }
  `;

  document.head.appendChild(style);
}

Tagify.prototype._originalLoadOriginalValues = Tagify.prototype.loadOriginalValues;
Tagify.prototype.loadOriginalValues = function(value) {
  if( value === undefined ){
    const persistedOriginalValue = this.getPersistedData('value')

    if( persistedOriginalValue && !this.DOM.originalInput.value )
      value = persistedOriginalValue
    else
      value = this.settings.mixMode.integrated ? this.DOM.input.textContent : this.DOM.originalInput.value
  }

  if (value && typeof value === 'string' && this.settings.mode != 'mix') {
    const values = Array.isArray(value) ? value : String(value).split(this.settings.delimiters).map(v => v.trim()).filter(v => v.length);
    value = values.map(value => ({ value }));
  }

  return this._originalLoadOriginalValues(value);
};

dmx.Component('tagify', {

  extends: 'form-element',

  initialData: {
    items: [],
    values: [],
  },

  attributes: {
    settings: {
      type: Object,
      default: {},
    },

    data: {
      type: Array,
      default: null,
    },

    tagValue: {
      type: String,
      default: '$value',
    },

    tagText: {
      type: String,
      default: '$value',
    },

    tagSecondary: {
      type: String,
      default: null,
    },

    tagImage: {
      type: String,
      default: null,
    },

    tagClass: {
      type: String,
      default: null,
    },

    tagCount: {
      type: String,
      default: null,
    },

    tagReadonly: {
      type: String,
      default: null,
    },

    nocustom: {
      type: Boolean,
      default: false,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    delimiters: {
      type: String,
      default: ',',
    },

    duplicates: {
      type: Boolean,
      default: false,
    },

    noinput: {
      type: Boolean,
      default: false,
    },

    maxTags: {
      type: Number,
      default: Infinity,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    mode: {
      type: String,
      default: null,
    },

    notrim: {
      type: Boolean,
      default: false,
    },

    noautocomplete: {
      type: Boolean,
      default: false,
    },

    keepInvalid: {
      type: Boolean,
      default: false,
    },

    skipInvalid: {
      type: Boolean,
      default: false,
    },

    minChars: {
      type: Number,
      default: 2,
    },

    caseSensitive: {
      type: Boolean,
      default: false,
    },

    maxItems: {
      type: Number,
      default: 10,
    },

    noFuzzySearch: {
      type: Boolean,
      default: false,
    },

    noAccentedSearch: {
      type: Boolean,
      default: false,
    },

    dropdownPosition: {
      type: String,
      default: 'all',
      enum: ['all', 'text', 'input'],
    },

    highlightFirst: {
      type: Boolean,
      default: false,
    },

    noCloseOnSelect: {
      type: Boolean,
      default: false,
    },

    pattern: {
      type: String,
      default: null,
    },

    dragsort: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    addEmptyTag () {
      this._tagify.addEmptyTag();
    },

    addTags (tags, clear, skipInvalids) {
      this._tagify.addTags(tags, clear, skipInvalids);
      this._updateData();
    },

    removeTags (tags) {
      this._tagify.removeTags(tags);
      this._updateData();
    },

    removeAllTags () {
      this._tagify.removeAllTags();
      this._updateData();
    },
  },

  events: {
    change: Event,
    add: Event,
    remove: Event,
    invalid: Event,
    input: Event,
    focus: Event,
    blur: Event,
    noresults: Event,
  },

  init (node) {
    this._formdataHandler = this._formdataHandler.bind(this);
    this._updateData = this._updateData.bind(this);

    this._transformTag = tag => {
      delete tag.class;
      delete tag.count;
      delete tag.image;
      delete tag.__dmx;
      delete tag.__item;

      const found = this._whitelist().find(data => data.value == tag.value);// || data.label == tag.value);

      if (found) {
        Object.assign(tag, found);
      }
    };

    dmx.Component('form-element').prototype.init.call(this, node);

    if (node.form) {
      node.form.addEventListener('formdata', this._formdataHandler);
      this._form = node.form;
    }
  },

  destroy () {
    if (this._form) {
      this._form.removeEventListener('formdata', this._formdataHandler);
    }

    dmx.Component('form-element').prototype.destroy.call(this);

    this._tagify.destroy();
  },

  render (node) {
    ensureTagifyThemeStyles();

    this._tagify = new Tagify(node, {
      enforceWhitelist: this.props.nocustom,
      whitelist: this._whitelist(),
      tagTextProp: 'label',
      delimiters: this.props.delimiters,
      duplicates: this.props.duplicates,
      userInput: !this.props.noinput,
      maxTags: this.props.maxTags,
      mode: this.props.mode,
      trim: !this.props.notrim,
      keepInvalidTags: this.props.keepInvalid,
      skipInvalid: this.props.skipInvalid,
      pattern: this.props.pattern && this.props.pattern.startsWith('/') ? new RegExp(this.props.pattern.replace(/^\/|\/$/, '')) : this.props.pattern,
      autoComplete: {
        enabled: !this.props.noautocomplete,
        rightKey: !this.props.noautocomplete,
      },
      dropdown: {
        enabled: this.props.minChars >= 0 ? this.props.minChars : false,
        searchKeys: ['label'],
        caseSensitive: this.props.caseSensitive,
        maxItems: this.props.maxItems,
        fuzzySearch: !this.props.noFuzzySearch,
        accentedSearch: !this.props.noAccentedSearch,
        position: this.props.dropdownPosition,
        highlightFirst: this.props.highlightFirst,
        closeOnSelect: !this.props.noCloseOnSelect,
      },
      originalInputValueFormat: tags => Array.isArray(tags) ? tags.map(tag => tag.value).join(this.props.delimiters[0]) : (tags.value || JSON.stringify(tags)),
      transformTag: this._transformTag,
      templates: this._templates,
      ...this.props.settings,
    });

    if (this.props.nocustom && !this.props.data) {
      this._tagify.loading(true);
      this._tagify.setDisabled(true);
    } else {
      this._tagify.loading(this.props.loading);
    }

    this._tagify.setReadonly(this.props.readonly);

    this._tagify.on('add', ({detail}) => {
      this.dispatchEvent('add', null, {
        item: detail.data.__item,
        value: detail.data.value,
        isCustom: !detail.data.__item,
      });
    });

    this._tagify.on('remove', ({detail}) => {
      this.dispatchEvent('remove', null, {
        item: detail.data.__item,
        value: detail.data.value,
        isCustom: detail.data.__item,
      });
    });

    this._tagify.on('invalid', ({detail}) => {
      this.dispatchEvent('invalid', null, {
        value: detail.data.value,
        message: detail.message,
      });
    });

    this._tagify.on('input', ({detail}) => {
      this.dispatchEvent('input', null, {
        value: detail.value,
        isValid: detail.isValid,
      });
    });

    this._tagify.on('dropdown:noMatch', ({detail}) => {
      this.dispatchEvent('noresults', null, {
        value: detail.value,
      });
    });

    this._tagify.on('change', this._updateData);
    this._tagify.on('focus', () => this.set('focused', true));
    this._tagify.on('blur', () => this.set('focused', false));

    this._tagify.on('change', () => this.dispatchEvent('change'));
    this._tagify.on('focus', () => this.dispatchEvent('focus'));
    this._tagify.on('blur', () => this.dispatchEvent('blur'));

    if (this.props.dragsort) {
      this._setDragSort(true);
    }

    this._updateData();
  },

  performUpdate (updatedProps) {
    if (!this._tagify) return;

    if (updatedProps.has('dragSort')) {
      this._setDragSort(this.props.dragsort);
    }

    if (updatedProps.has('disabled')) {
      this._tagify.setDisabled(this.props.disabled);
      this.set('disabled', this.props.disabled);
    }

    if (updatedProps.has('readonly')) {
      this._tagify.setReadonly(this.props.readonly);
    }

    if (updatedProps.has('data')) {
      this._tagify.whitelist = this._whitelist();

      if (this.props.nocustom) {
        this._setValue(this.props.value || '', true);
        this._tagify.loading(this.props.loading);
        this._tagify.setDisabled(this.props.disabled);
      } else {
        this._tagify.getTagElms().forEach(tag => {
          const tagData = this._tagify.getSetTagData(tag);

          if (!tagData.__dmx) {
            const found = this._whitelist().find(data => data.value == tagData.value);

            if (found) {
              Object.assign(tagData, found);
              this._tagify.replaceTag(tag, tagData);
            }
          }
        });
        this._updateData();
      }
    }

    if (updatedProps.has('value')) {
      this._setValue(this.props.value, true);
    }

    if (updatedProps.has('loading')) {
      this._tagify.loading(this.props.loading);
    }
  },

  _setDragSort (enable) {
    if (this._dragsort) {
      this._dragsort.destroy();
    }

    if (enable) {
      if (window.DragSort) {
        this._dragsort = new DragSort(this._tagify.DOM.scope, {
          selector: '.' + this._tagify.settings.classNames.tag,
          callbacks: {
            dragEnd: () => this._tagify.updateValueByDOMTags()
          }
        });
      } else {
        console.warn('DragSort is not loaded');
      }
    }
  },

  _updateData () {
    const tags = this._tagify.getCleanValue();
    this.set('items', tags.map(tag => tag.__item));
    this.set('values', tags.map(tag => tag.value));
  },

  _templates: {
    wrapper (input, _s) {
      return `
        <tags
          class="${_s.classNames.namespace} ${_s.mode ? _s.classNames[_s.mode + 'Mode'] : ''} ${input.className}"
          ${_s.readonly ? 'readonly' : ''}
          ${_s.disabled ? 'disabled' : ''}
          ${_s.required ? 'required' : ''}
          ${input.hasAttribute('dmxDomId') ? `dmxDomId="${input.getAttribute('dmxDomId')}"` : ''}
          ${input.hasAttribute('style') ? `style="${input.getAttribute('style')}"` : ''}
          tabindex="-1"
        ><span
          ${!_s.readonly && _s.userInput ? 'contenteditable' : ''}
          tabindex="0"
          data-placeholder="${_s.placeholder || '&#8203;'}"
          aria-placeholder="${_s.placeholder || ''}"
          class="${_s.classNames.input}"
          role="textbox"
          aria-autocomplete="both"
          aria-multiline="${_s.mode == 'mix'}"
        ></span>&#8203;</tags>
      `;
    },

    tag (tagData) {
      const _s = this.settings;

      return `
        <tag
          ${tagData.readonly ? 'readonly' : ''}
          title="${tagData.title || tagData.value}"
          contenteditable="false"
          spellcheck="false"
          tabindex="${_s.a11y.focusableTags ? 0 : -1}"
          class="${_s.classNames.tag} ${tagData.class || ''}"
          style="white-space:nowrap;${tagData.style || ''}"
        >
          <x
            title=""
            class="${_s.classNames.tagX}"
            role="button"
            aria-label="remove tag"
          ></x>
          <div
            ${_s.mode != 'select' ? 'style="display:flex;align-items:center;"' : ''}
          >
            ${tagData.image ? `
              <img
                onerror="this.style.visibility='hidden'"
                src="${tagData.image}"
                style="height:var(--tag-img-size, 1em);margin-right:.3em;pointer-events:none;"
              >
            ` : ''}
            <span
              class="${_s.classNames.tagText}"
            >${tagData[_s.tagTextProp] || tagData.value}</span>
          </div>
        </tag>
      `;
    },

    dropdownItem (item) {
      const style = getComputedStyle(this.DOM.originalInput);
      const gap = style.getPropertyValue('--item-gap') || '.3em';
      const img_size = style.getPropertyValue('--item-img-size') || '1em';
      const text_color = style.getPropertyValue('--item-text-color') || 'inherit';
      const sec_color = style.getPropertyValue('--item-sec-color') || 'inherit';
      const sec_size = style.getPropertyValue('--items-sec-size') || '.75em';
      const count_color = style.getPropertyValue('--item_count-color') || 'inherit';

      return `
        <div
          value="${item.value}"
          class="${this.settings.classNames.dropdownItem} ${item.class || ''}"
          style="display:flex;align-items:center;gap:var(--item-gap, ${gap})"
          tabindex="0"
          role="option"
        >
          ${item.image ? `
            <img
              onerror="this.style.visibility='hidden'"
              src="${item.image}"
              style="height:var(--item-img-size, ${img_size});pointerevents:none"
            >
          ` : ''}
          <div style="color:var(--item-text-color, ${text_color})">
            ${item.label}
            ${item.secondary ? `
              <br>
              <span style="color:var(--item-sec-color, ${sec_color});font-size:${sec_size}">
                ${item.secondary}
              </span>
            ` : ''}
          </div>
          ${item.count ? `
            <div style="color:var(--item-count-color, ${count_color}">
              (${item.count})
            </div>
          ` : ''}
        </div>
      `;
    },
  },

  _setValue (value, defaultValue) {
    dmx.Component('form-element').prototype._setValue.call(this, value, defaultValue);
    this._tagify.loadOriginalValues(this.props.value);
    this._updateData();
  },

  _whitelist () {
    return Array.isArray(this.props.data) ? this.props.data.map(item => {
      if (!item) {
        console.warn('Invalid tag data:', item, 'in', this.props.data);
        return null;
      }

      const scope = dmx.DataScope(item, this);
      const tagData = {
        __dmx: true,
        __item: item,
        value: String(dmx.parse(this.props.tagValue, scope)),
        label: String(dmx.parse(this.props.tagText, scope)),
      };

      if (!this.props.notrim) tagData.value = tagData.value.trim();
      if (!this.props.notrim) tagData.label = tagData.label.trim();

      if (item.style) tagData.style = item.style;
      if (this.props.tagSecondary) tagData.secondary = dmx.parse(this.props.tagSecondary, scope);
      if (this.props.tagImage) tagData.image = dmx.parse(this.props.tagImage, scope);
      if (this.props.tagClass) tagData.class = dmx.parse(this.props.tagClass, scope);
      if (this.props.tagCount) tagData.count = dmx.parse(this.props.tagCount, scope);
      if (this.props.tagReadonly) tagData.readonly = !!dmx.parse(this.props.tagReadonly, scope);

      return tagData;
    }) : [];
  },

  _formdataHandler (event) {
    const formData = event.formData;
    let _name = this.$node.name;

    if (_name && this.props.mode != 'select' && this.props.mode != 'mix') {
      formData.delete(this.$node.name);

      if (Array.isArray(this.data.values)) {
        if (_name.slice(-2) != '[]') _name += '[]';
        this.data.values.forEach(value => {
          formData.append(_name, value);
        })
      }
    }
  },

  _resetHandler (event) {
    if (this._tagify) {
      if (this.$node.defaultValue) {
        this._setValue(this.$node.defaultValue);
        this._tagify.loadOriginalValues(this.$node.defaultValue);
      } else {
        this._tagify.removeAllTags();
      }

      this._updateData();
    }

    dmx.Component('form-element').prototype._resetHandler.call(this, event);
  },

});
